import { Merchant } from '@stax-core/types-omni';
import { AuthDatum } from '../../../context';
import { onboardingapi } from '../../../api';
import { CloneSection, CloneMerchantPayload } from './CloneMerchantModal.types';

export async function cloneMerchant(
  authToken: string,
  selectedMerchant: Merchant,
  companyName: string,
  selectedSections: CloneSection[],
): Promise<AuthDatum[]> {
  // Create omit array from unchecked sections
  const omitSections = selectedSections
    .filter(section => !section.checked)
    .map(section => section.apiName);

  // Build the enhanced clone payload
  const payload: CloneMerchantPayload = {
    overrides: {
      name: companyName,
    },
    omit: omitSections,
    // Note: user_ids will be handled by the backend - current user is automatically linked
  };

  // Call the clone endpoint on underwriting service
  return await onboardingapi.post(
    authToken,
    `/merchant/${selectedMerchant.id}/clone`,
    payload,
  );
}
